import { theme } from "../theme";
import "./Icons.scss";
type Props = {
  backgroundColor?: string;
};
export const ControlKeyIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="#7f8899"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4588 11.3281H13.5923C13.5582 11.0866 13.4886 10.8722 13.3835 10.6847C13.2784 10.4943 13.1435 10.3324 12.9787 10.1989C12.8139 10.0653 12.6236 9.96307 12.4077 9.89205C12.1946 9.82102 11.9631 9.78551 11.7131 9.78551C11.2614 9.78551 10.8679 9.89773 10.5327 10.1222C10.1974 10.3437 9.9375 10.6676 9.75284 11.0938C9.56818 11.517 9.47585 12.0312 9.47585 12.6364C9.47585 13.2585 9.56818 13.7812 9.75284 14.2045C9.94034 14.6278 10.2017 14.9474 10.5369 15.1634C10.8722 15.3793 11.2599 15.4872 11.7003 15.4872C11.9474 15.4872 12.1761 15.4545 12.3864 15.3892C12.5994 15.3239 12.7884 15.2287 12.9531 15.1037C13.1179 14.9759 13.2543 14.821 13.3622 14.6392C13.473 14.4574 13.5497 14.25 13.5923 14.017L15.4588 14.0256C15.4105 14.4261 15.2898 14.8125 15.0966 15.1847C14.9063 15.554 14.6491 15.8849 14.3253 16.1776C14.0043 16.4673 13.6207 16.6974 13.1747 16.8679C12.7315 17.0355 12.2301 17.1193 11.6705 17.1193C10.892 17.1193 10.196 16.9432 9.58239 16.5909C8.97159 16.2386 8.48864 15.7287 8.13352 15.0611C7.78125 14.3935 7.60511 13.5852 7.60511 12.6364C7.60511 11.6847 7.78409 10.875 8.14205 10.2074C8.5 9.53977 8.9858 9.03125 9.59943 8.68182C10.2131 8.32955 10.9034 8.15341 11.6705 8.15341C12.1761 8.15341 12.6449 8.22443 13.0767 8.36648C13.5114 8.50852 13.8963 8.71591 14.2315 8.98864C14.5668 9.25852 14.8395 9.58949 15.0497 9.98153C15.2628 10.3736 15.3991 10.8224 15.4588 11.3281Z"
        fill="#03C2DD"
      />
    </svg>
  );
};

export const BinIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 4.5H3.75H15.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 4.5V3C6 2.60218 6.15804 2.22064 6.43934 1.93934C6.72064 1.65804 7.10218 1.5 7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5M14.25 4.5V15C14.25 15.3978 14.092 15.7794 13.8107 16.0607C13.5294 16.342 13.1478 16.5 12.75 16.5H5.25C4.85218 16.5 4.47064 16.342 4.18934 16.0607C3.90804 15.7794 3.75 15.3978 3.75 15V4.5H14.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const SelectedSceneEditContentIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2222 11.6537C12.2829 13.0278 11.174 14.1897 9.74553 14.2481C9.64032 14.2525 4.51106 14.2422 4.51106 14.2422C3.08954 14.3501 1.84543 13.3286 1.73331 11.9597C1.72486 11.8577 1.72717 6.35414 1.72717 6.35414C1.66419 4.97862 2.77161 3.81374 4.2008 3.75313C4.30754 3.74796 9.4299 3.75757 9.4299 3.75757C10.8583 3.65113 12.1063 4.68001 12.2169 6.05553C12.2245 6.15458 12.2222 11.6537 12.2222 11.6537Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2246 7.48488L14.6944 5.46363C15.3064 4.96263 16.2244 5.39913 16.2236 6.18888L16.2146 11.7006C16.2139 12.4904 15.2951 12.9231 14.6846 12.4221L12.2246 10.4009"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ColorIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.088 13.5731C13.962 13.5731 14.676 12.8334 14.676 11.9282C14.676 10.8349 13.088 9.05098 13.088 9.05098C13.088 9.05098 11.5 10.8349 11.5 11.9282C11.5 12.8334 12.214 13.5731 13.088 13.5731ZM5.546 12.672C5.688 12.8171 5.918 12.8171 6.058 12.672L11.18 7.44075C11.322 7.29566 11.322 7.06066 11.18 6.91762L6.06 1.68639C6.048 1.67413 6.034 1.66187 6.02 1.65165L4.456 0.0536769C4.4219 0.0192843 4.37591 0 4.328 0C4.28009 0 4.2341 0.0192843 4.2 0.0536769L3.24 1.03453C3.20634 1.06937 3.18746 1.11636 3.18746 1.16531C3.18746 1.21427 3.20634 1.26125 3.24 1.29609L4.584 2.66929L0.428 6.91762C0.286 7.06271 0.286 7.2977 0.428 7.44075L5.546 12.672ZM5.804 3.50506L9.382 7.16079H2.228L5.804 3.50506ZM15.84 15.0383H0.16C0.072 15.0383 0 15.1119 0 15.2018V16.8365C0 16.9264 0.072 17 0.16 17H8H15.84C15.928 17 16 16.9264 16 16.8365V15.2018C16 15.1119 15.928 15.0383 15.84 15.0383Z"
        fill="var(--blings_black)"
      />
    </svg>
  );
};
export const ImageIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 15L16 10L5 21"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AudioIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 21C7.65685 21 9 19.6569 9 18C9 16.3431 7.65685 15 6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21Z"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 18V5L21 3V16"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 19C19.6569 19 21 17.6569 21 16C21 14.3431 19.6569 13 18 13C16.3431 13 15 14.3431 15 16C15 17.6569 16.3431 19 18 19Z"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const MediaIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.82 2H4.18C2.97602 2 2 2.97602 2 4.18V19.82C2 21.024 2.97602 22 4.18 22H19.82C21.024 22 22 21.024 22 19.82V4.18C22 2.97602 21.024 2 19.82 2Z"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 2V22"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 2V22"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12H22"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 7H7"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 17H7"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 17H22"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 7H22"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PerVideoKeyIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="#7f8899"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.75852 17V8.27273H12.2017C12.8636 8.27273 13.4276 8.39915 13.8935 8.65199C14.3594 8.90199 14.7145 9.25 14.9588 9.69602C15.206 10.1392 15.3295 10.6506 15.3295 11.2301C15.3295 11.8097 15.2045 12.321 14.9545 12.7642C14.7045 13.2074 14.3423 13.5526 13.8679 13.7997C13.3963 14.0469 12.8253 14.1705 12.1548 14.1705H9.96023V12.6918H11.8565C12.2116 12.6918 12.5043 12.6307 12.7344 12.5085C12.9673 12.3835 13.1406 12.2116 13.2543 11.9929C13.3707 11.7713 13.429 11.517 13.429 11.2301C13.429 10.9403 13.3707 10.6875 13.2543 10.4716C13.1406 10.2528 12.9673 10.0838 12.7344 9.96449C12.5014 9.84233 12.206 9.78125 11.848 9.78125H10.6037V17H8.75852Z"
        fill="#7f8899"
      />
    </svg>
  );
};
export const ShowInDemoPageIcon = ({ color = "white" }: { color?: string }) => {
  return (
    <svg
      color={color}
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2048 5.83738L7.22133 9.86343L2.69065 7.02966C2.0415 6.62352 2.17653 5.63749 2.91078 5.42277L13.6678 2.27257C14.3402 2.0755 14.9633 2.70413 14.7636 3.37867L11.5811 14.1282C11.3631 14.8635 10.3827 14.9949 9.98039 14.3429L7.21922 9.86414"
        stroke="currentColor"
        strokeWidth="1.044"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FormInteractiveIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 17H8"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13H8"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9H9H8"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2V8H20"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EditIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.89551 12.417H13.1455"
        stroke="var(--blings_black)"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5205 2.79212C10.7526 2.56006 11.0673 2.42969 11.3955 2.42969C11.558 2.42969 11.7189 2.46169 11.8691 2.52388C12.0192 2.58607 12.1556 2.67722 12.2705 2.79212C12.3854 2.90703 12.4766 3.04344 12.5388 3.19358C12.6009 3.34371 12.6329 3.50462 12.6329 3.66712C12.6329 3.82963 12.6009 3.99054 12.5388 4.14067C12.4766 4.2908 12.3854 4.42722 12.2705 4.54212L4.97884 11.8338L2.64551 12.4171L3.22884 10.0838L10.5205 2.79212Z"
        stroke="var(--blings_black)"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const GoToFrameIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 5V19"
        stroke="var(--blings_black)"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 4L15 12L5 20V4Z"
        stroke="var(--blings_black)"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const TimeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6V12L16 14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PublishedVersionIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_14812)">
        <path
          d="M8 17L12 21L16 17"
          stroke="#7f8899"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12V21"
          stroke="#7f8899"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.8802 18.0899C21.7496 17.4786 22.4015 16.6061 22.7415 15.5991C23.0814 14.5921 23.0916 13.503 22.7706 12.4898C22.4496 11.4766 21.814 10.592 20.9562 9.96449C20.0985 9.33697 19.063 8.9991 18.0002 8.99993H16.7402C16.4394 7.82781 15.8767 6.73918 15.0943 5.81601C14.3119 4.89285 13.3303 4.15919 12.2234 3.67029C11.1164 3.18138 9.91302 2.94996 8.7037 2.99345C7.49439 3.03694 6.31069 3.3542 5.24173 3.92136C4.17277 4.48851 3.2464 5.29078 2.53236 6.26776C1.81833 7.24474 1.33523 8.37098 1.11944 9.56168C0.903647 10.7524 0.960787 11.9765 1.28656 13.142C1.61233 14.3074 2.19824 15.3837 3.00018 16.2899"
          stroke="#7f8899"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_14812">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const CopyUrl = ({ color = "white" }: { color?: string }) => {
  return (
    <svg
      color={color}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 11.25H3C2.60218 11.25 2.22064 11.092 1.93934 10.8107C1.65804 10.5294 1.5 10.1478 1.5 9.75V3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H9.75C10.1478 1.5 10.5294 1.65804 10.8107 1.93934C11.092 2.22064 11.25 2.60218 11.25 3V3.75M8.25 6.75H15C15.8284 6.75 16.5 7.42157 16.5 8.25V15C16.5 15.8284 15.8284 16.5 15 16.5H8.25C7.42157 16.5 6.75 15.8284 6.75 15V8.25C6.75 7.42157 7.42157 6.75 8.25 6.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    // <svg
    //   width="20"
    //   height="19"
    //   viewBox="0 0 20 19"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M9.74688 1.92238H5.11709C3.66941 1.91682 2.48273 3.07009 2.44863 4.51777V12.0687C2.42427 13.4955 3.56083 14.6724 4.98833 14.6975C5.03079 14.6975 5.07394 14.6975 5.11709 14.6961H10.6767C12.1168 14.6815 13.2749 13.5087 13.2728 12.0687V5.59587L9.74688 1.92238Z"
    //     fill="#f2f4f8"
    //     stroke="#7f8899"
    //     strokeWidth="1.044"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M13.2264 4.01003H8.59658C7.1489 4.00446 5.96222 5.15773 5.92812 6.60541V14.1563C5.90376 15.5831 7.04033 16.7601 8.46782 16.7851C8.51028 16.7851 8.55343 16.7851 8.59658 16.7837H14.1562C15.5963 16.7691 16.7544 15.5963 16.7523 14.1563V7.68352L13.2264 4.01003Z"
    //     fill="#f2f4f8"
    //     stroke="#7f8899"
    //     strokeWidth="1.044"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <path
    //     d="M13.0439 4.00171V6.02637C13.0439 7.01469 13.8436 7.81579 14.832 7.81857H16.7488"
    //     stroke="#7f8899"
    //     strokeWidth="1.044"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    // </svg>
  );
};
export const AIPlusIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 3.80005H5C3.89543 3.80005 3 4.69548 3 5.80005V19.8C3 20.9046 3.89543 21.8 5 21.8H19C20.1046 21.8 21 20.9046 21 19.8V5.80005C21 4.69548 20.1046 3.80005 19 3.80005Z"
        stroke="#7f8899"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8.80005V16.8"
        stroke="#7f8899"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12.8H16"
        stroke="#7f8899"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ExportMp4Icon = ({ color = "white" }: { color?: string }) => {
  return (
    <svg
      color={color}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 11.25V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V11.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 7.5L9 11.25L12.75 7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11.25V2.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    // <svg
    //   width="17"
    //   height="17"
    //   viewBox="0 0 17 17"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M8.6227 10.8915L8.6227 2.51099"
    //     stroke="#7f8899"
    //     strokeWidth="1.044"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <path
    //     d="M10.6523 8.85376L8.62281 10.8916L6.59327 8.85376"
    //     stroke="#7f8899"
    //     strokeWidth="1.044"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <path
    //     d="M11.8471 5.80493H12.4965C13.9128 5.80493 15.0605 6.95264 15.0605 8.36969L15.0605 11.769C15.0605 13.1818 13.9156 14.3268 12.5027 14.3268L4.74931 14.3268C3.33295 14.3268 2.18455 13.1784 2.18455 11.762L2.18455 8.36204C2.18455 6.94985 3.33016 5.80493 4.74235 5.80493H5.39798"
    //     stroke="#7f8899"
    //     strokeWidth="1.044"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    // </svg>
  );
};
export const TextIcon = ({ backgroundColor = "transparent" }: Props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 13.333H10"
        stroke="var(--blings_black)"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66699 4.66699V2.66699H13.3337V4.66699"
        stroke="var(--blings_black)"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 2.66699V13.3337"
        stroke="var(--blings_black)"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LinkIcon = ({ backgroundColor = "transparent" }: Props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13C10.4295 13.5741 10.9774 14.0491 11.6066 14.3929C12.2357 14.7367 12.9315 14.9411 13.6467 14.9923C14.3618 15.0435 15.0796 14.9403 15.7513 14.6897C16.4231 14.4392 17.0331 14.047 17.54 13.54L20.54 10.54C21.4508 9.59695 21.9548 8.33394 21.9434 7.02296C21.932 5.71198 21.4061 4.45791 20.4791 3.53087C19.5521 2.60383 18.298 2.07799 16.987 2.0666C15.676 2.0552 14.413 2.55918 13.47 3.46997L11.75 5.17997"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0002 11.0002C13.5707 10.4261 13.0228 9.95104 12.3936 9.60729C11.7645 9.26353 11.0687 9.05911 10.3535 9.00789C9.63841 8.95667 8.92061 9.05986 8.24885 9.31044C7.5771 9.56103 6.96709 9.95316 6.4602 10.4602L3.4602 13.4602C2.54941 14.4032 2.04544 15.6662 2.05683 16.9772C2.06822 18.2882 2.59407 19.5423 3.52111 20.4693C4.44815 21.3964 5.70221 21.9222 7.01319 21.9336C8.32418 21.945 9.58719 21.441 10.5302 20.5302L12.2402 18.8202"
        stroke="var(--blings_black)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ExpressionIcon = ({ backgroundColor = "transparent" }: Props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4004 2.65039C13.7639 2.65039 13.1534 2.90325 12.7033 3.35333C12.2532 3.80342 12.0004 4.41387 12.0004 5.05039V14.6504C12.0004 15.2869 12.2532 15.8974 12.7033 16.3474C13.1534 16.7975 13.7639 17.0504 14.4004 17.0504C15.0369 17.0504 15.6474 16.7975 16.0974 16.3474C16.5475 15.8974 16.8004 15.2869 16.8004 14.6504C16.8004 14.0139 16.5475 13.4034 16.0974 12.9533C15.6474 12.5032 15.0369 12.2504 14.4004 12.2504H4.80039C4.16387 12.2504 3.55342 12.5032 3.10333 12.9533C2.65325 13.4034 2.40039 14.0139 2.40039 14.6504C2.40039 15.2869 2.65325 15.8974 3.10333 16.3474C3.55342 16.7975 4.16387 17.0504 4.80039 17.0504C5.43691 17.0504 6.04736 16.7975 6.49745 16.3474C6.94753 15.8974 7.20039 15.2869 7.20039 14.6504V5.05039C7.20039 4.41387 6.94753 3.80342 6.49745 3.35333C6.04736 2.90325 5.43691 2.65039 4.80039 2.65039C4.16387 2.65039 3.55342 2.90325 3.10333 3.35333C2.65325 3.80342 2.40039 4.41387 2.40039 5.05039C2.40039 5.68691 2.65325 6.29736 3.10333 6.74745C3.55342 7.19753 4.16387 7.45039 4.80039 7.45039H14.4004C15.0369 7.45039 15.6474 7.19753 16.0974 6.74745C16.5475 6.29736 16.8004 5.68691 16.8004 5.05039C16.8004 4.41387 16.5475 3.80342 16.0974 3.35333C15.6474 2.90325 15.0369 2.65039 14.4004 2.65039Z"
        stroke="var(--blings_black)"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DynamicSceneIcon = ({
  backgroundColor = "transparent",
}: Props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4 17.4504C15.7255 17.4504 16.8 16.3759 16.8 15.0504C16.8 13.7249 15.7255 12.6504 14.4 12.6504C13.0745 12.6504 12 13.7249 12 15.0504C12 16.3759 13.0745 17.4504 14.4 17.4504Z"
        stroke="var(--blings_black)"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.7998 7.85059V17.4506"
        stroke="var(--blings_black)"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4004 5.4502H12.8004C13.2247 5.4502 13.6317 5.61877 13.9318 5.91882C14.2318 6.21888 14.4004 6.62585 14.4004 7.0502V12.6502"
        stroke="var(--blings_black)"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.80039 7.85078C6.12587 7.85078 7.20039 6.77626 7.20039 5.45078C7.20039 4.1253 6.12587 3.05078 4.80039 3.05078C3.47491 3.05078 2.40039 4.1253 2.40039 5.45078C2.40039 6.77626 3.47491 7.85078 4.80039 7.85078Z"
        stroke="var(--blings_black)"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const RedoIcon = () => {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.98973 0.105975C2.53179 0.419895 1.33507 1.55174 0.899892 3.01955C0.704118 3.68402 0.7186 4.70633 0.943427 5.38547C1.40032 6.81665 2.5899 7.89737 4.04775 8.20409C4.96163 8.40128 5.81025 8.28446 6.70965 7.83896C7.21733 7.58336 8.05147 6.89702 8.05147 6.72899C8.05147 6.69245 7.88466 6.52451 7.6888 6.36386L7.31888 6.0791L6.98526 6.4004C6.32526 7.04309 5.25181 7.37888 4.35965 7.21823C3.06137 6.99188 2.04593 5.96957 1.80653 4.63325C1.50188 2.9903 2.70584 1.35464 4.41757 1.07717C5.47654 0.909225 6.87638 1.49342 7.3406 2.30396L7.46388 2.52302L6.88362 2.80049L6.30336 3.07796L7.66698 3.89579C8.41405 4.34849 9.05233 4.69904 9.07415 4.66979C9.09578 4.64783 9.19018 4.03448 9.2844 3.3116C9.37147 2.58872 9.46569 1.88771 9.48027 1.75622L9.5238 1.52258L8.96535 1.78547C8.6606 1.93154 8.39957 2.04107 8.39233 2.0264C7.65983 0.953056 6.78939 0.332326 5.65793 0.0913057C5.07042 -0.0328045 4.59896 -0.0328045 3.98973 0.105975Z"
        fill={theme.blings_blue}
      />
    </svg>
  );
};

export const SettingsIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6338 6.47591L17.068 5.49401C16.5893 4.66317 15.5284 4.37655 14.6965 4.85328V4.85328C14.3004 5.08658 13.8279 5.15277 13.383 5.03725C12.9381 4.92174 12.5574 4.63401 12.3249 4.23751C12.1753 3.98549 12.095 3.69844 12.0919 3.40539V3.40539C12.1054 2.93556 11.9282 2.48027 11.6005 2.14324C11.2729 1.80621 10.8228 1.61614 10.3528 1.61633H9.2128C8.75231 1.61633 8.31081 1.79982 7.98598 2.12621C7.66115 2.45261 7.47977 2.89498 7.48199 3.35546V3.35546C7.46834 4.3062 6.69369 5.06973 5.74286 5.06963C5.44981 5.06659 5.16276 4.98621 4.91074 4.83664V4.83664C4.07876 4.35991 3.0179 4.64653 2.5392 5.47737L1.93175 6.47591C1.45362 7.30571 1.73634 8.36591 2.56416 8.84745V8.84745C3.10225 9.15812 3.43373 9.73226 3.43373 10.3536C3.43373 10.9749 3.10225 11.5491 2.56416 11.8597V11.8597C1.73739 12.338 1.45437 13.3957 1.93175 14.2229V14.2229L2.50591 15.2132C2.7302 15.6179 3.10653 15.9165 3.55161 16.043C3.99669 16.1695 4.47383 16.1134 4.87745 15.8872V15.8872C5.27423 15.6557 5.74706 15.5922 6.19083 15.711C6.63461 15.8297 7.01256 16.1208 7.24067 16.5196C7.39025 16.7716 7.47062 17.0587 7.47367 17.3517V17.3517C7.47367 18.3122 8.2523 19.0908 9.2128 19.0908H10.3528C11.3101 19.0909 12.0874 18.3173 12.0919 17.36V17.36C12.0897 16.8981 12.2722 16.4545 12.5989 16.1278C12.9255 15.8012 13.3691 15.6187 13.8311 15.6209C14.1234 15.6287 14.4093 15.7088 14.6632 15.8539V15.8539C15.493 16.332 16.5532 16.0493 17.0347 15.2215V15.2215L17.6338 14.2229C17.8658 13.8249 17.9294 13.3508 17.8107 12.9057C17.692 12.4606 17.4008 12.0811 17.0014 11.8514V11.8514C16.6021 11.6217 16.3109 11.2422 16.1922 10.7971C16.0735 10.352 16.1371 9.87792 16.369 9.47987C16.5198 9.21657 16.7381 8.99826 17.0014 8.84745V8.84745C17.8243 8.36617 18.1064 7.31217 17.6338 6.48423V6.48423V6.47591Z"
        stroke="currentColor"
        strokeWidth="1.36364"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="9.78713"
        cy="10.3537"
        r="2.39651"
        stroke="currentColor"
        strokeWidth="1.36364"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ArrowDown = ({ color = "white" }: { color?: string }) => {
  return (
    <svg
      color={color}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9L12 15L18 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BellIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.79948 15.3604C14.9688 15.3604 17.3602 14.6972 17.5911 12.0355C17.5911 9.3756 15.9239 9.54665 15.9239 6.28306C15.9239 3.73384 13.5076 0.833374 9.79948 0.833374C6.09135 0.833374 3.67509 3.73384 3.67509 6.28306C3.67509 9.54665 2.00781 9.3756 2.00781 12.0355C2.23969 14.7073 4.63111 15.3604 9.79948 15.3604Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9889 18.1191C10.7385 19.5076 8.78781 19.5241 7.52539 18.1191"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CopyIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="3" fill="currentBackgroundColor" />
      <path
        d="M20.1875 9.9375H12.3359C12.2715 9.9375 12.2188 9.99023 12.2188 10.0547V10.875C12.2188 10.9395 12.2715 10.9922 12.3359 10.9922H19.6016V21.0703C19.6016 21.1348 19.6543 21.1875 19.7188 21.1875H20.5391C20.6035 21.1875 20.6562 21.1348 20.6562 21.0703V10.4062C20.6562 10.147 20.4468 9.9375 20.1875 9.9375ZM18.3125 11.8125H10.8125C10.5532 11.8125 10.3438 12.022 10.3438 12.2812V20.0552C10.3438 20.1797 10.3936 20.2983 10.4814 20.3862L13.02 22.9248C13.0522 22.957 13.0889 22.9834 13.1284 23.0054V23.0332H13.1899C13.2412 23.0522 13.2954 23.0625 13.3511 23.0625H18.3125C18.5718 23.0625 18.7812 22.853 18.7812 22.5938V12.2812C18.7812 12.022 18.5718 11.8125 18.3125 11.8125ZM13.5957 22.125H13.5928L11.3984 19.9307V19.9277H13.5957V22.125Z"
        fill="currentColor"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2502_7841"
          x1="0"
          y1="16.4"
          x2="32"
          y2="16.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F4F2" />
          <stop offset="1" stopColor="#F7F7F7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BlingsLogo = () => {
  return (
    <svg
      width="94"
      height="28"
      viewBox="0 0 94 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5139_22001"
        maskUnits="userSpaceOnUse"
        x="1"
        y="2"
        width="26"
        height="23"
      >
        <path
          d="M15.2495 11.3269C15.2855 11.4003 15.3336 11.4737 15.3937 11.5349C15.5139 11.6572 15.6821 11.7307 15.8624 11.7307H26.3299C26.4501 11.7307 26.5703 11.694 26.6664 11.6328C26.7626 11.5716 26.8467 11.4859 26.9068 11.3758C26.9669 11.2657 26.9909 11.1556 26.9789 11.0332C26.9789 10.9109 26.9308 10.8007 26.8587 10.7028L22.2919 3.04315C22.2318 2.95749 22.1477 2.88408 22.0516 2.83513C21.9554 2.78619 21.8593 2.76172 21.7511 2.76172H15.8143C15.6461 2.76172 15.4778 2.83513 15.3456 2.95749C15.2254 3.07985 15.1533 3.25116 15.1533 3.42246L15.1894 11.0699C15.1894 11.1556 15.2014 11.2412 15.2374 11.3146L15.2495 11.3269Z"
          fill="white"
        />
        <path
          d="M26.6791 14.2273C26.5709 14.1539 26.4388 14.1172 26.3066 14.1172H15.815C15.6467 14.1172 15.4785 14.1784 15.3583 14.3007C15.2982 14.3497 15.2501 14.4231 15.2141 14.4965C15.178 14.5699 15.166 14.6556 15.166 14.729V23.6612C15.166 23.7836 15.2021 23.9059 15.2742 24.0038C15.3463 24.1017 15.4424 24.1874 15.5626 24.2363C15.6828 24.2852 15.803 24.2975 15.9352 24.2852C16.0553 24.2608 16.1755 24.2118 16.2717 24.1262L26.7632 15.2062C26.8594 15.1205 26.9315 15.0104 26.9555 14.8881C26.9796 14.7657 26.9796 14.6433 26.9195 14.521C26.8714 14.3986 26.7873 14.3007 26.6791 14.2395V14.2273Z"
          fill="white"
        />
        <path
          d="M12.618 2.95749C12.4978 2.83513 12.3296 2.76172 12.1493 2.76172H6.21251C6.10435 2.76172 6.00821 2.78619 5.91207 2.83513C5.81593 2.88408 5.7318 2.95749 5.67171 3.04315L1.11695 10.7028C1.04484 10.8007 1.00879 10.9109 1.00879 11.0332C1.00879 11.1556 1.02081 11.2657 1.0809 11.3758C1.14099 11.4859 1.22511 11.5716 1.32125 11.6328C1.4174 11.694 1.53757 11.7307 1.65775 11.7307H12.1373C12.3056 11.7307 12.4738 11.6572 12.606 11.5349C12.7262 11.4125 12.7983 11.2412 12.7983 11.0699L12.8223 3.42246C12.8223 3.33681 12.8103 3.25116 12.7743 3.17774C12.7382 3.10432 12.6901 3.03091 12.63 2.96973L12.618 2.95749Z"
          fill="white"
        />
        <path
          d="M12.6182 14.3007C12.486 14.1906 12.3298 14.1172 12.1615 14.1172H1.65791C1.52571 14.1172 1.39352 14.1539 1.28536 14.2273C1.1772 14.3007 1.09307 14.3986 1.045 14.5087C0.996927 14.6189 0.98491 14.7535 1.02096 14.8758C1.05702 14.9982 1.11711 15.1083 1.21325 15.1939L11.7168 24.1139C11.813 24.1996 11.9332 24.2485 12.0533 24.273C12.1735 24.2975 12.3057 24.273 12.4259 24.2241C12.5461 24.1751 12.6422 24.1017 12.7143 23.9916C12.7864 23.8937 12.8225 23.7713 12.8225 23.649V14.7167C12.8225 14.6311 12.7984 14.5577 12.7744 14.4843C12.7504 14.4108 12.6903 14.3497 12.6302 14.2885L12.6182 14.3007Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_5139_22001)">
        <rect
          x="-1.80029"
          y="-1.58203"
          width="31.6217"
          height="29.9494"
          fill="url(#paint0_linear_5139_22001)"
        />
      </g>
      <path
        d="M42.7337 20.538H35.7148V5.06641H43.2263C45.1261 5.10161 46.463 5.64725 47.2546 6.72093C47.7296 7.37218 47.9759 8.16424 47.9759 9.07951C47.9759 9.99478 47.7296 10.7868 47.2546 11.3677C46.9908 11.6845 46.6038 11.9837 46.076 12.2477C46.8676 12.5294 47.4657 12.987 47.8703 13.6206C48.2749 14.2367 48.4684 14.9936 48.4684 15.8912C48.4684 16.7889 48.2397 17.6337 47.7824 18.3554C47.4833 18.8306 47.1139 19.2531 46.6741 19.5699C46.1816 19.9395 45.5835 20.2035 44.915 20.3444C44.2466 20.4852 43.5077 20.5556 42.7161 20.5556L42.7337 20.538ZM44.2641 10.7692C44.6863 10.5228 44.8974 10.0652 44.8974 9.41393C44.8974 8.76268 44.616 8.21704 44.053 7.98823C43.5781 7.82981 42.9624 7.74181 42.206 7.74181H38.8109V11.1565H42.6106C43.2966 11.1565 43.842 11.0333 44.2641 10.7692ZM42.6633 13.7263H38.8109V17.8626H42.6106C43.2966 17.8626 43.8244 17.7746 44.1938 17.5809C44.8798 17.2465 45.2141 16.5953 45.2141 15.6448C45.2141 14.6943 44.8798 14.2895 44.2114 13.9903C43.842 13.8143 43.3142 13.7263 42.6458 13.7263H42.6633Z"
        fill="black"
      />
      <path
        d="M49.5947 5.06641H52.5852V20.5556H49.5947V5.06641Z"
        fill="black"
      />
      <path
        d="M57.16 4.96094V7.72434H54.1343V4.96094H57.16ZM57.16 9.09725V20.5557H54.1343V9.09725H57.16Z"
        fill="black"
      />
      <path
        d="M64.0211 11.3158C63.0008 11.3158 62.3147 11.7382 61.9277 12.6007C61.7342 13.0583 61.6287 13.6391 61.6287 14.3432V20.5389H58.6558V9.11561H61.5407V10.7877C61.9277 10.2069 62.2971 9.78446 62.6314 9.52044C63.2471 9.0628 64.0211 8.83398 64.971 8.83398C65.9209 8.83398 67.1171 9.15081 67.8735 9.76685C68.6299 10.3829 68.9994 11.4214 68.9994 12.8471V20.5565H65.9385V13.5863C65.9385 12.9879 65.8505 12.5303 65.6922 12.1958C65.3932 11.615 64.8303 11.3158 64.0211 11.3158Z"
        fill="black"
      />
      <path
        d="M74.2856 22.5454C74.6023 22.827 75.1476 22.9502 75.9216 22.9502C76.6956 22.9502 77.7159 22.5982 78.0853 21.8766C78.3316 21.4189 78.4371 20.6445 78.4371 19.5532V18.8139C78.1557 19.3068 77.839 19.6764 77.5048 19.9228C76.9067 20.3804 76.1327 20.6093 75.1828 20.6093C73.7051 20.6093 72.5441 20.0988 71.6646 19.0604C70.785 18.0219 70.3452 16.6314 70.3452 14.8712C70.3452 13.1111 70.7674 11.7382 71.6118 10.5765C72.4562 9.41483 73.6523 8.83398 75.218 8.83398C76.7836 8.83398 76.291 8.92199 76.7132 9.098C77.4344 9.39723 78.0325 9.96047 78.4723 10.7525V9.098H81.3749V19.958C81.3749 21.4365 81.1286 22.5454 80.636 23.3023C79.7741 24.5872 78.1381 25.2384 75.7281 25.2384C73.3181 25.2384 73.0718 24.9568 72.1395 24.3759C71.2072 23.7951 70.697 22.9502 70.6091 21.8062H73.8634C73.9514 22.1582 74.0921 22.4046 74.268 22.563L74.2856 22.5454ZM73.7755 16.6314C74.1801 17.5994 74.9013 18.0747 75.9568 18.0747C77.0123 18.0747 77.2409 17.8107 77.7335 17.2826C78.226 16.7546 78.4547 15.9097 78.4547 14.748C78.4547 13.5863 78.226 12.8295 77.7687 12.2662C77.3113 11.703 76.6956 11.4214 75.9216 11.4214C75.1476 11.4214 74.1449 11.9142 73.7403 12.8999C73.5292 13.4279 73.4237 14.0792 73.4237 14.836C73.4237 15.5929 73.5292 16.0857 73.7579 16.6138L73.7755 16.6314Z"
        fill="black"
      />
      <path
        d="M91.1352 9.61449C92.0324 10.1953 92.5425 11.181 92.6833 12.5715H89.6928C89.6576 12.1843 89.5344 11.8851 89.3761 11.6562C89.0419 11.2514 88.479 11.0402 87.705 11.0402C86.931 11.0402 86.5967 11.1458 86.3153 11.3394C86.0338 11.5506 85.8931 11.7794 85.8931 12.0611C85.8931 12.3427 86.0338 12.6595 86.3329 12.8003C86.6319 12.9587 87.6698 13.2404 89.4465 13.6276C90.6427 13.9092 91.5223 14.3316 92.1204 14.8949C92.7009 15.4757 92.9999 16.1798 92.9999 17.0422C92.9999 17.9047 92.5777 19.1016 91.7333 19.8233C90.889 20.5449 89.5872 20.8969 87.8281 20.8969C86.069 20.8969 84.6969 20.5097 83.8525 19.7528C82.9905 18.996 82.5684 18.0279 82.5684 16.8486H85.594C85.6644 17.3767 85.7875 17.7639 85.9986 17.9751C86.368 18.3799 87.0541 18.5736 88.0568 18.5736C89.0595 18.5736 89.1123 18.4856 89.4641 18.3095C89.8159 18.1335 89.9918 17.8695 89.9918 17.5175C89.9918 17.1655 89.8511 16.919 89.5696 16.743C89.2882 16.567 88.2503 16.2678 86.456 15.8454C85.1543 15.5285 84.2395 15.1237 83.7118 14.6309C83.184 14.1556 82.9202 13.4692 82.9202 12.5715C82.9202 11.6738 83.3424 10.6002 84.1691 9.8433C84.9959 9.08645 86.157 8.69922 87.6698 8.69922C89.1826 8.69922 90.2557 8.98084 91.1704 9.54408L91.1352 9.61449Z"
        fill="black"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5139_22001"
          x1="67.8891"
          y1="-8.26494"
          x2="55.3147"
          y2="-28.9439"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF164E" />
          <stop offset="1" stopColor="#FF7AAA" />
          <stop offset="1.0001" stopColor="#FF7AAA" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const RestoreIcon = () => {
  return (
    <svg
      className="Restore"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="21" height="21" rx="3" fill="currentBackgroundColor" />
      <path
        d="M15.0192 9.45446C15.0467 9.97431 15.065 10.5748 15.065 11.2739C15.065 12.5019 15.0375 13.4161 14.9183 14.1062C14.7992 14.7964 14.6067 15.2087 14.3317 15.4776C14.0567 15.7465 13.6258 15.9436 12.9292 16.0512C12.2233 16.1677 11.2883 16.1946 10.0325 16.1946C8.77667 16.1946 7.84167 16.1677 7.13583 16.0512C6.43 15.9347 6.00833 15.7465 5.73333 15.4776C5.45833 15.2087 5.25667 14.7874 5.14667 14.1062C5.0275 13.4161 5 12.5019 5 11.2739C5 10.046 5.0275 9.13179 5.14667 8.44164C5.26583 7.75149 5.45833 7.3392 5.73333 7.07031C6.00833 6.80142 6.43917 6.60423 7.13583 6.49668C7.84167 6.38016 8.77667 6.35327 10.0325 6.35327C11.2883 6.35327 12.2233 6.38016 12.9292 6.49668C13.635 6.6132 14.0567 6.80142 14.3317 7.07031"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <path
        d="M12.7734 5L14.6068 6.79259L12.7734 8.58519"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DeleteIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6H5H21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 11V17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11V17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UploadIcon = () => {
  return (
    <svg
      className="upload-icon"
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.625"
        width="21"
        height="21"
        rx="3"
        fill="currentBackgroundColor"
      />
      <g clipPath="url(#clip0_2048_7555)">
        <path
          d="M16.1654 12.1551C16.147 12.7178 16.101 13.1867 16.0366 13.5874C15.9171 14.2438 15.7239 14.636 15.448 14.8917C15.1721 15.1475 14.7398 15.335 14.0408 15.4373C13.3326 15.5481 12.3945 15.5737 11.1345 15.5737C9.87442 15.5737 8.93629 15.5481 8.2281 15.4373C7.5199 15.3265 7.09683 15.1475 6.82091 14.8917C6.54499 14.636 6.34265 14.2353 6.23228 13.5874C6.1587 13.1782 6.12191 12.6922 6.10352 12.0955"
          stroke="currentColor"
          strokeLinecap="round"
        />
        <path
          d="M10.8173 7.44819C10.4586 7.78067 10.0999 8.10462 9.74124 8.4371C9.69525 8.47973 9.64926 8.52235 9.59408 8.54793C9.40094 8.65023 9.1618 8.59908 9.02384 8.42858C8.89508 8.27513 8.90428 8.05347 9.05144 7.90002C9.13421 7.81477 9.22619 7.73804 9.30896 7.66131C9.8516 7.15833 10.3942 6.65535 10.9369 6.16089C11.1576 5.95628 11.406 5.95628 11.6267 6.16089C12.2429 6.73207 12.8591 7.30326 13.4754 7.88297C13.7145 8.11315 13.6593 8.44563 13.365 8.57351C13.1902 8.65023 12.9971 8.61613 12.8499 8.47973C12.5096 8.1643 12.1693 7.84887 11.829 7.52491L11.7279 7.43114C11.7279 7.49081 11.7279 7.52491 11.7279 7.55901C11.7279 9.17879 11.7279 10.7986 11.7187 12.4183C11.7187 12.5462 11.7003 12.6656 11.5991 12.7594C11.4611 12.8872 11.3048 12.9299 11.1208 12.8702C10.9369 12.8105 10.8357 12.6826 10.8173 12.5036C10.8173 12.461 10.8173 12.4269 10.8173 12.3842C10.8173 10.773 10.8173 9.16174 10.8265 7.55901C10.8265 7.52491 10.8449 7.48229 10.8541 7.44819C10.8357 7.44819 10.8173 7.44819 10.7989 7.44819L10.8173 7.44819Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2048_7555">
          <rect
            width="11"
            height="10"
            fill="currentColor"
            transform="translate(5.625 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const OpenLinkIcon = (props: { width?: number; height?: number }) => {
  const { width, height } = props;
  return (
    <svg
      width={width || "32"}
      height={height || "32"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="3" fill="currentBackgroundColor" />
      <g clipPath="url(#clip0_2502_7840)">
        <path
          d="M22.94 15.1111C22.9643 15.6444 22.9643 16.237 22.9643 16.8889C22.9643 18.5126 22.9279 19.7215 22.77 20.6341C22.6122 21.5466 22.3572 22.0918 21.9929 22.4474C21.6286 22.8029 21.0579 23.0637 20.135 23.2059C19.2 23.36 17.9615 23.3955 16.2979 23.3955C14.6343 23.3955 13.3958 23.36 12.4608 23.2059C11.5258 23.0518 10.9672 22.8029 10.6029 22.4474C10.2386 22.0918 9.97147 21.5348 9.82576 20.6341C9.6679 19.7215 9.63147 18.5126 9.63147 16.8889C9.63147 15.2652 9.6679 14.0563 9.82576 13.1437C9.98361 12.2311 10.2386 11.6859 10.6029 11.3304C10.9672 10.9748 11.5379 10.7141 12.4608 10.5718C13.3958 10.4178 14.6343 10.3822 16.2979 10.3822C17.3179 10.3822 18.18 10.3941 18.9086 10.4415"
          stroke="currentColor"
          strokeLinecap="round"
        />
        <path
          d="M23.9358 9.14963C23.2679 9.14963 22.6 9.14963 21.9443 9.14963C21.8593 9.14963 21.7743 9.14963 21.7015 9.12593C21.41 9.04296 21.2522 8.78222 21.2886 8.48593C21.325 8.21333 21.5558 8.01185 21.8472 8C22.005 8 22.175 8 22.3329 8C23.3286 8 24.3365 8 25.3565 8C25.7693 8 26 8.22519 26 8.62815C26 9.75407 26 10.88 26 12.0059C26 12.4444 25.6115 12.7289 25.2108 12.5867C24.9679 12.5037 24.8222 12.2904 24.8222 12.0296C24.8222 11.4015 24.8222 10.7852 24.8222 10.157V9.97926C24.8222 9.97926 24.725 10.0622 24.6886 10.0978C23.0615 11.6859 21.4222 13.2859 19.795 14.8741C19.6615 15.0044 19.5279 15.0993 19.3458 15.0993C19.0908 15.0993 18.8965 15.0044 18.7872 14.7793C18.6779 14.5541 18.7143 14.3407 18.8722 14.1511C18.9086 14.1037 18.945 14.0681 18.9815 14.0326C20.5965 12.4444 22.2236 10.8681 23.8386 9.28C23.875 9.24444 23.9358 9.22074 23.9843 9.19704C23.9722 9.17333 23.9479 9.16148 23.9358 9.13778V9.14963Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2502_7840"
          x1="0"
          y1="16.4"
          x2="32"
          y2="16.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F4F2" />
          <stop offset="1" stopColor="#F7F7F7" />
        </linearGradient>
        <clipPath id="clip0_2502_7840">
          <rect
            width="17"
            height="16"
            fill="white"
            transform="translate(9 8)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const AIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1114 15.4933C11.2589 15.4955 11.3557 15.3791 11.3698 15.1968C11.4 14.8002 11.4141 14.4003 11.4703 14.0077C11.7305 12.1951 12.8977 10.8436 14.5787 10.4169C14.9484 10.323 15.3321 10.2893 15.7103 10.2364C15.8737 10.2136 15.9938 10.124 15.9996 9.98517C16.0068 9.81188 15.9124 9.71908 15.7645 9.6763C15.7264 9.66543 15.6856 9.66651 15.6461 9.65963C15.225 9.58567 14.7922 9.55341 14.3848 9.4287C13.127 9.04443 12.213 8.22585 11.7192 6.92548C11.4587 6.23923 11.3609 5.51926 11.3561 4.78261C11.3547 4.54045 11.2606 4.40486 11.1014 4.40124C10.9384 4.39725 10.855 4.52703 10.8354 4.76883C10.8004 5.20096 10.7843 5.63889 10.705 6.06268C10.4548 7.40329 9.79139 8.443 8.62724 9.0872C7.96967 9.45081 7.26507 9.63606 6.52306 9.66253C6.31268 9.66978 6.20251 9.77708 6.20697 9.95798C6.21143 10.1349 6.31576 10.2175 6.52031 10.2371C6.81547 10.2654 7.11234 10.2911 7.40372 10.347C9.11597 10.6754 10.3669 11.9569 10.7081 13.7561C10.7949 14.2147 10.8107 14.6889 10.8509 15.1569C10.8691 15.3708 10.9521 15.4912 11.1117 15.4937L11.1114 15.4933ZM5.79307 13.523C5.78929 13.3526 5.66436 13.2558 5.4351 13.2464C4.29395 13.1993 3.45173 12.4547 3.22487 11.2779C3.18059 11.0492 3.17545 10.8114 3.15691 10.5775C3.14113 10.3814 3.04366 10.2563 2.89711 10.2556C2.74541 10.2549 2.64863 10.3734 2.6373 10.5714C2.62975 10.7041 2.62152 10.8364 2.61225 10.9691C2.53503 12.094 1.85617 12.9307 0.815232 13.1728C0.637795 13.2142 0.454524 13.2268 0.273313 13.249C0.0962193 13.2707 -0.00399631 13.3722 0.00012214 13.5321C0.00424059 13.6873 0.0975921 13.7782 0.270224 13.7953C0.367007 13.8047 0.463791 13.8134 0.560575 13.8239C1.52292 13.9294 2.26321 14.5762 2.51306 15.5629C2.58754 15.8573 2.60367 16.1691 2.63524 16.474C2.65721 16.686 2.75262 16.8053 2.92491 16.7999C3.06185 16.7959 3.12156 16.7005 3.13083 16.4852C3.13735 16.3344 3.14422 16.1832 3.16275 16.0339C3.26983 15.1714 3.63809 14.4924 4.40103 14.0991C4.73909 13.9247 5.09842 13.8362 5.47457 13.8221C5.67466 13.8145 5.7965 13.6974 5.79238 13.523H5.79307ZM8.0716 4.07388C8.074 3.91981 7.97996 3.8154 7.81385 3.79329C7.67211 3.77444 7.52796 3.77226 7.38828 3.74398C6.49972 3.56236 5.85347 3.06135 5.58405 2.12387C5.48899 1.79361 5.47594 1.43653 5.43373 1.09032C5.41211 0.910869 5.33283 0.8061 5.18731 0.8003C5.03561 0.794137 4.93162 0.901806 4.91721 1.08561C4.91034 1.17587 4.91343 1.26687 4.90966 1.3575C4.85371 2.60675 4.17898 3.46665 3.03885 3.73021C2.86141 3.77117 2.67608 3.77371 2.4959 3.8038C2.36068 3.82628 2.27728 3.91872 2.28243 4.06518C2.28758 4.21454 2.36514 4.31387 2.51409 4.33163C2.61637 4.34396 2.71967 4.34613 2.8216 4.36172C3.74791 4.50274 4.44805 4.97148 4.74972 5.94341C4.85646 6.28708 4.86882 6.66446 4.91446 7.02771C4.93814 7.21804 5.02944 7.33513 5.18662 7.33658C5.32699 7.33767 5.40627 7.2358 5.41966 7.03931C5.43304 6.84681 5.4351 6.65214 5.46359 6.46218C5.59915 5.55805 6.03983 4.88883 6.86489 4.56292C7.15387 4.44873 7.47408 4.41719 7.78262 4.36462C7.96177 4.33417 8.06954 4.24535 8.07194 4.07424L8.0716 4.07388Z"
        fill="#a6a8b1"
      />
    </svg>
  );
};

interface SpinnerIconProps {
  // optional prop for spinning color
  color?: string;
}

export const SpinnerIcon: React.FC<SpinnerIconProps> = ({ color }) => {
  return (
    <svg
      className="SpinnerIcon"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="7"
        cy="7"
        r="6.5"
        transform="matrix(0.600716 -0.799462 -0.799462 -0.600716 9.19336 17.6025)"
        stroke="url(#paint0_linear_2097_7818)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2097_7818"
          x1="-5.76254e-08"
          y1="6.9229"
          x2="14"
          y2="6.9229"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const SearchIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="9.80589"
        cy="9.80541"
        r="7.49047"
        stroke="#7f8899"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0156 15.4043L17.9523 18.3334"
        stroke="#7f8899"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TitleCsv = () => {
  return (
    <svg
      width="30"
      height="34"
      viewBox="0 0 30 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 15C0 1.35 1.35 0 15 0C28.65 0 30 1.35 30 15C30 28.65 28.65 30 15 30C1.35 30 0 28.65 0 15Z"
        fill="#FF0046"
      />
      <path
        d="M4.35511 12.995V11.7273H10.3281V12.995H8.10156V19H6.58168V12.995H4.35511ZM11.2834 19V13.5455H12.7962V19H11.2834ZM12.0433 12.8423C11.8184 12.8423 11.6255 12.7678 11.4645 12.6186C11.3059 12.4671 11.2266 12.286 11.2266 12.0753C11.2266 11.867 11.3059 11.6882 11.4645 11.5391C11.6255 11.3875 11.8184 11.3118 12.0433 11.3118C12.2682 11.3118 12.46 11.3875 12.6186 11.5391C12.7796 11.6882 12.8601 11.867 12.8601 12.0753C12.8601 12.286 12.7796 12.4671 12.6186 12.6186C12.46 12.7678 12.2682 12.8423 12.0433 12.8423ZM16.9093 13.5455V14.6818H13.6245V13.5455H16.9093ZM14.3702 12.2386H15.883V17.3239C15.883 17.4635 15.9043 17.5724 15.9469 17.6506C15.9895 17.7263 16.0487 17.7796 16.1245 17.8104C16.2026 17.8411 16.2926 17.8565 16.3944 17.8565C16.4654 17.8565 16.5364 17.8506 16.6074 17.8388C16.6784 17.8246 16.7329 17.8139 16.7708 17.8068L17.0087 18.9325C16.9329 18.9562 16.8264 18.9834 16.6891 19.0142C16.5518 19.0473 16.3849 19.0675 16.1884 19.0746C15.8238 19.0888 15.5042 19.0402 15.2296 18.929C14.9573 18.8177 14.7454 18.6449 14.5939 18.4105C14.4424 18.1761 14.3678 17.8802 14.3702 17.5227V12.2386ZM19.5247 11.7273V19H18.0119V11.7273H19.5247ZM23.2223 19.1065C22.6612 19.1065 22.1783 18.9929 21.7734 18.7656C21.371 18.536 21.0608 18.2116 20.843 17.7926C20.6252 17.3712 20.5163 16.8729 20.5163 16.2976C20.5163 15.7365 20.6252 15.2441 20.843 14.8203C21.0608 14.3965 21.3674 14.0663 21.7628 13.8295C22.1605 13.5928 22.6269 13.4744 23.1619 13.4744C23.5218 13.4744 23.8568 13.5324 24.1669 13.6484C24.4794 13.7621 24.7517 13.9337 24.9837 14.1634C25.218 14.393 25.4003 14.6818 25.5305 15.0298C25.6607 15.3755 25.7259 15.7803 25.7259 16.2443V16.6598H21.12V15.7223H24.3018C24.3018 15.5045 24.2545 15.3116 24.1598 15.1435C24.0651 14.9754 23.9337 14.844 23.7656 14.7493C23.5999 14.6522 23.407 14.6037 23.1868 14.6037C22.9571 14.6037 22.7536 14.657 22.576 14.7635C22.4008 14.8677 22.2635 15.0085 22.1641 15.1861C22.0646 15.3613 22.0137 15.5566 22.0114 15.772V16.6634C22.0114 16.9332 22.0611 17.1664 22.1605 17.3629C22.2623 17.5594 22.4055 17.7109 22.5902 17.8175C22.7749 17.924 22.9938 17.9773 23.2472 17.9773C23.4152 17.9773 23.5691 17.9536 23.7088 17.9062C23.8485 17.8589 23.968 17.7879 24.0675 17.6932C24.1669 17.5985 24.2427 17.4825 24.2947 17.3452L25.6939 17.4375C25.6229 17.7737 25.4773 18.0672 25.2571 18.3182C25.0393 18.5668 24.7576 18.7609 24.4119 18.9006C24.0687 19.0379 23.6721 19.1065 23.2223 19.1065Z"
        fill="white"
      />
      <path d="M15.5 34L12.4689 28.75L18.5311 28.75L15.5 34Z" fill="#ff3666" />
    </svg>
  );
};
export const DescriptionSvg = () => {
  return (
    <svg
      width="62"
      height="34"
      viewBox="0 0 62 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 15C0 1.35 2.79 0 31 0C59.21 0 62 1.35 62 15C62 28.65 59.21 30 31 30C2.79 30 0 28.65 0 15Z"
        fill="#FF0046"
      />
      <path
        d="M6.31179 19H3.73366V11.7273H6.3331C7.06463 11.7273 7.69437 11.8729 8.2223 12.1641C8.75024 12.4529 9.15625 12.8684 9.44034 13.4105C9.7268 13.9527 9.87003 14.6013 9.87003 15.3565C9.87003 16.1141 9.7268 16.7652 9.44034 17.3097C9.15625 17.8542 8.74787 18.272 8.2152 18.5632C7.6849 18.8544 7.05043 19 6.31179 19ZM5.27131 17.6825H6.24787C6.70241 17.6825 7.08475 17.602 7.39489 17.4411C7.70739 17.2777 7.94176 17.0256 8.09801 16.6847C8.25663 16.3414 8.33594 15.8987 8.33594 15.3565C8.33594 14.8191 8.25663 14.38 8.09801 14.0391C7.94176 13.6982 7.70857 13.4472 7.39844 13.2862C7.0883 13.1252 6.70597 13.0447 6.25142 13.0447H5.27131V17.6825ZM13.4664 19.1065C12.9054 19.1065 12.4224 18.9929 12.0176 18.7656C11.6151 18.536 11.305 18.2116 11.0872 17.7926C10.8694 17.3712 10.7605 16.8729 10.7605 16.2976C10.7605 15.7365 10.8694 15.2441 11.0872 14.8203C11.305 14.3965 11.6116 14.0663 12.0069 13.8295C12.4047 13.5928 12.871 13.4744 13.4061 13.4744C13.7659 13.4744 14.1009 13.5324 14.411 13.6484C14.7235 13.7621 14.9958 13.9337 15.2278 14.1634C15.4622 14.393 15.6445 14.6818 15.7747 15.0298C15.9049 15.3755 15.97 15.7803 15.97 16.2443V16.6598H11.3642V15.7223H14.546C14.546 15.5045 14.4986 15.3116 14.4039 15.1435C14.3092 14.9754 14.1779 14.844 14.0098 14.7493C13.844 14.6522 13.6511 14.6037 13.4309 14.6037C13.2013 14.6037 12.9977 14.657 12.8201 14.7635C12.6449 14.8677 12.5076 15.0085 12.4082 15.1861C12.3088 15.3613 12.2579 15.5566 12.2555 15.772V16.6634C12.2555 16.9332 12.3052 17.1664 12.4047 17.3629C12.5065 17.5594 12.6497 17.7109 12.8343 17.8175C13.019 17.924 13.238 17.9773 13.4913 17.9773C13.6594 17.9773 13.8133 17.9536 13.9529 17.9062C14.0926 17.8589 14.2122 17.7879 14.3116 17.6932C14.411 17.5985 14.4868 17.4825 14.5389 17.3452L15.938 17.4375C15.867 17.7737 15.7214 18.0672 15.5012 18.3182C15.2834 18.5668 15.0017 18.7609 14.6561 18.9006C14.3128 19.0379 13.9163 19.1065 13.4664 19.1065ZM21.4956 15.1009L20.1106 15.1861C20.0869 15.0677 20.036 14.9612 19.9579 14.8665C19.8798 14.7694 19.7768 14.6925 19.649 14.6357C19.5235 14.5765 19.3732 14.5469 19.198 14.5469C18.9636 14.5469 18.7659 14.5966 18.6049 14.696C18.444 14.7931 18.3635 14.9233 18.3635 15.0866C18.3635 15.2169 18.4155 15.3269 18.5197 15.4169C18.6239 15.5069 18.8026 15.5791 19.0559 15.6335L20.0431 15.8324C20.5734 15.9413 20.9688 16.1165 21.2292 16.358C21.4896 16.5994 21.6199 16.9167 21.6199 17.3097C21.6199 17.6671 21.5145 17.9808 21.3038 18.2507C21.0955 18.5206 20.809 18.7313 20.4444 18.8828C20.0822 19.032 19.6644 19.1065 19.1909 19.1065C18.4688 19.1065 17.8935 18.9562 17.465 18.6555C17.0389 18.3525 16.7891 17.9406 16.7157 17.4197L18.2037 17.3416C18.2486 17.5618 18.3575 17.7299 18.5304 17.8459C18.7032 17.9595 18.9245 18.0163 19.1944 18.0163C19.4596 18.0163 19.6726 17.9654 19.8336 17.8636C19.997 17.7595 20.0798 17.6257 20.0822 17.4624C20.0798 17.325 20.0218 17.2126 19.9082 17.125C19.7946 17.035 19.6194 16.9664 19.3826 16.919L18.438 16.7308C17.9054 16.6243 17.5088 16.4396 17.2484 16.1768C16.9904 15.9141 16.8613 15.5791 16.8613 15.1719C16.8613 14.8215 16.956 14.5196 17.1454 14.2663C17.3372 14.013 17.6059 13.8177 17.9515 13.6804C18.2995 13.5431 18.7067 13.4744 19.1731 13.4744C19.862 13.4744 20.4042 13.62 20.7995 13.9112C21.1973 14.2024 21.4293 14.599 21.4956 15.1009ZM25.0369 19.1065C24.4782 19.1065 23.9976 18.9882 23.5952 18.7514C23.1951 18.5123 22.8873 18.1809 22.6719 17.7571C22.4588 17.3333 22.3523 16.8456 22.3523 16.294C22.3523 15.7353 22.46 15.2453 22.6754 14.8239C22.8932 14.4001 23.2022 14.0698 23.6023 13.8331C24.0024 13.594 24.4782 13.4744 25.0298 13.4744C25.5057 13.4744 25.9223 13.5608 26.2798 13.7337C26.6373 13.9065 26.9202 14.1491 27.1286 14.4616C27.3369 14.7741 27.4517 15.1411 27.473 15.5625H26.0455C26.0052 15.2902 25.8987 15.0713 25.7259 14.9055C25.5554 14.7375 25.3317 14.6534 25.0547 14.6534C24.8203 14.6534 24.6155 14.7173 24.4403 14.8452C24.2675 14.9706 24.1326 15.1541 24.0355 15.3956C23.9384 15.6371 23.8899 15.9295 23.8899 16.2727C23.8899 16.6207 23.9373 16.9167 24.032 17.1605C24.129 17.4044 24.2652 17.5902 24.4403 17.718C24.6155 17.8459 24.8203 17.9098 25.0547 17.9098C25.2275 17.9098 25.3826 17.8743 25.5199 17.8033C25.6596 17.7322 25.7744 17.6293 25.8643 17.4943C25.9567 17.357 26.017 17.1925 26.0455 17.0007H27.473C27.4493 17.4174 27.3357 17.7843 27.1321 18.1016C26.9309 18.4164 26.6527 18.6626 26.2976 18.8402C25.9425 19.0178 25.5223 19.1065 25.0369 19.1065ZM28.4416 19V13.5455H29.9082V14.4972H29.965C30.0645 14.1586 30.2314 13.9029 30.4657 13.7301C30.7001 13.5549 30.97 13.4673 31.2754 13.4673C31.3511 13.4673 31.4328 13.4721 31.5204 13.4815C31.608 13.491 31.685 13.504 31.7512 13.5206V14.8629C31.6802 14.8416 31.582 14.8227 31.4565 14.8061C31.331 14.7895 31.2162 14.7812 31.112 14.7812C30.8895 14.7812 30.6906 14.8298 30.5154 14.9268C30.3426 15.0215 30.2053 15.1541 30.1035 15.3246C30.0041 15.495 29.9544 15.6915 29.9544 15.9141V19H28.4416ZM32.5334 19V13.5455H34.0462V19H32.5334ZM33.2933 12.8423C33.0684 12.8423 32.8755 12.7678 32.7145 12.6186C32.5559 12.4671 32.4766 12.286 32.4766 12.0753C32.4766 11.867 32.5559 11.6882 32.7145 11.5391C32.8755 11.3875 33.0684 11.3118 33.2933 11.3118C33.5182 11.3118 33.71 11.3875 33.8686 11.5391C34.0296 11.6882 34.1101 11.867 34.1101 12.0753C34.1101 12.286 34.0296 12.4671 33.8686 12.6186C33.71 12.7678 33.5182 12.8423 33.2933 12.8423ZM35.258 21.0455V13.5455H36.7495V14.4616H36.8169C36.8832 14.3149 36.9791 14.1657 37.1046 14.0142C37.2324 13.8603 37.3981 13.7325 37.6017 13.6307C37.8077 13.5265 38.0634 13.4744 38.3688 13.4744C38.7665 13.4744 39.1335 13.5786 39.4696 13.7869C39.8058 13.9929 40.0745 14.3042 40.2757 14.7209C40.477 15.1352 40.5776 15.6548 40.5776 16.2798C40.5776 16.8883 40.4793 17.402 40.2828 17.821C40.0887 18.2377 39.8236 18.5537 39.4874 18.7692C39.1536 18.9822 38.7795 19.0888 38.3652 19.0888C38.0717 19.0888 37.8219 19.0402 37.6159 18.9432C37.4123 18.8461 37.2454 18.7242 37.1152 18.5774C36.985 18.4283 36.8856 18.2779 36.8169 18.1264H36.7708V21.0455H35.258ZM36.7388 16.2727C36.7388 16.5971 36.7838 16.88 36.8738 17.1214C36.9637 17.3629 37.0939 17.5511 37.2644 17.6861C37.4348 17.8187 37.642 17.8849 37.8858 17.8849C38.132 17.8849 38.3404 17.8175 38.5108 17.6825C38.6813 17.5452 38.8103 17.3558 38.8979 17.1143C38.9879 16.8705 39.0328 16.59 39.0328 16.2727C39.0328 15.9579 38.9891 15.6809 38.9015 15.4418C38.8139 15.2027 38.6848 15.0156 38.5144 14.8807C38.3439 14.7457 38.1344 14.6783 37.8858 14.6783C37.6396 14.6783 37.4313 14.7434 37.2608 14.8736C37.0927 15.0038 36.9637 15.1884 36.8738 15.4276C36.7838 15.6667 36.7388 15.9484 36.7388 16.2727ZM44.4874 13.5455V14.6818H41.2026V13.5455H44.4874ZM41.9483 12.2386H43.4611V17.3239C43.4611 17.4635 43.4824 17.5724 43.525 17.6506C43.5676 17.7263 43.6268 17.7796 43.7026 17.8104C43.7807 17.8411 43.8707 17.8565 43.9725 17.8565C44.0435 17.8565 44.1145 17.8506 44.1855 17.8388C44.2566 17.8246 44.311 17.8139 44.3489 17.8068L44.5868 18.9325C44.5111 18.9562 44.4045 18.9834 44.2672 19.0142C44.1299 19.0473 43.963 19.0675 43.7665 19.0746C43.4019 19.0888 43.0823 19.0402 42.8077 18.929C42.5355 18.8177 42.3236 18.6449 42.1721 18.4105C42.0205 18.1761 41.946 17.8802 41.9483 17.5227V12.2386ZM45.4728 19V13.5455H46.9856V19H45.4728ZM46.2328 12.8423C46.0079 12.8423 45.8149 12.7678 45.6539 12.6186C45.4953 12.4671 45.416 12.286 45.416 12.0753C45.416 11.867 45.4953 11.6882 45.6539 11.5391C45.8149 11.3875 46.0079 11.3118 46.2328 11.3118C46.4577 11.3118 46.6494 11.3875 46.8081 11.5391C46.969 11.6882 47.0495 11.867 47.0495 12.0753C47.0495 12.286 46.969 12.4671 46.8081 12.6186C46.6494 12.7678 46.4577 12.8423 46.2328 12.8423ZM50.6619 19.1065C50.1103 19.1065 49.6333 18.9893 49.2308 18.755C48.8307 18.5182 48.5218 18.1892 48.304 17.7678C48.0862 17.344 47.9773 16.8527 47.9773 16.294C47.9773 15.7306 48.0862 15.2382 48.304 14.8168C48.5218 14.393 48.8307 14.0639 49.2308 13.8295C49.6333 13.5928 50.1103 13.4744 50.6619 13.4744C51.2135 13.4744 51.6894 13.5928 52.0895 13.8295C52.492 14.0639 52.8021 14.393 53.0199 14.8168C53.2377 15.2382 53.3466 15.7306 53.3466 16.294C53.3466 16.8527 53.2377 17.344 53.0199 17.7678C52.8021 18.1892 52.492 18.5182 52.0895 18.755C51.6894 18.9893 51.2135 19.1065 50.6619 19.1065ZM50.669 17.9347C50.92 17.9347 51.1295 17.8636 51.2976 17.7216C51.4657 17.5772 51.5923 17.3807 51.6776 17.1321C51.7652 16.8835 51.8089 16.6006 51.8089 16.2834C51.8089 15.9661 51.7652 15.6832 51.6776 15.4347C51.5923 15.1861 51.4657 14.9896 51.2976 14.8452C51.1295 14.7008 50.92 14.6286 50.669 14.6286C50.4157 14.6286 50.2027 14.7008 50.0298 14.8452C49.8594 14.9896 49.7304 15.1861 49.6428 15.4347C49.5575 15.6832 49.5149 15.9661 49.5149 16.2834C49.5149 16.6006 49.5575 16.8835 49.6428 17.1321C49.7304 17.3807 49.8594 17.5772 50.0298 17.7216C50.2027 17.8636 50.4157 17.9347 50.669 17.9347ZM55.843 15.8466V19H54.3303V13.5455H55.772V14.5078H55.8359C55.9567 14.1906 56.1591 13.9396 56.4432 13.755C56.7273 13.5679 57.0717 13.4744 57.4766 13.4744C57.8554 13.4744 58.1856 13.5573 58.4673 13.723C58.7491 13.8887 58.968 14.1255 59.1243 14.4332C59.2805 14.7386 59.3587 15.1032 59.3587 15.527V19H57.8459V15.7969C57.8482 15.4631 57.763 15.2027 57.5902 15.0156C57.4174 14.8262 57.1795 14.7315 56.8764 14.7315C56.6728 14.7315 56.4929 14.7753 56.3366 14.8629C56.1828 14.9505 56.062 15.0784 55.9744 15.2464C55.8892 15.4122 55.8454 15.6122 55.843 15.8466Z"
        fill="white"
      />
      <path d="M30.5 34L27.4689 28.75L33.5311 28.75L30.5 34Z" fill="#ff3666" />
    </svg>
  );
};
export const ThumbnailSvg = () => {
  return (
    <svg
      width="60"
      height="34"
      viewBox="0 0 60 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 15C0 1.35 2.7 0 30 0C57.3 0 60 1.35 60 15C60 28.65 57.3 30 30 30C2.7 30 0 28.65 0 15Z"
        fill="#FF0046"
      />
      <path
        d="M3.35511 12.995V11.7273H9.32812V12.995H7.10156V19H5.58168V12.995H3.35511ZM11.7962 15.8466V19H10.2834V11.7273H11.7536V14.5078H11.8175C11.9406 14.1858 12.1394 13.9337 12.4141 13.7514C12.6887 13.5668 13.0331 13.4744 13.4474 13.4744C13.8262 13.4744 14.1565 13.5573 14.4382 13.723C14.7223 13.8864 14.9425 14.1219 15.0987 14.4297C15.2573 14.7351 15.3355 15.1009 15.3331 15.527V19H13.8203V15.7969C13.8227 15.4607 13.7375 15.1991 13.5646 15.0121C13.3942 14.825 13.1551 14.7315 12.8473 14.7315C12.6413 14.7315 12.459 14.7753 12.3004 14.8629C12.1442 14.9505 12.0211 15.0784 11.9311 15.2464C11.8435 15.4122 11.7985 15.6122 11.7962 15.8466ZM20.0215 16.6776V13.5455H21.5343V19H20.0819V18.0092H20.025C19.9019 18.3288 19.6971 18.5857 19.4107 18.7798C19.1266 18.974 18.7798 19.071 18.3702 19.071C18.0056 19.071 17.6848 18.9882 17.4078 18.8224C17.1309 18.6567 16.9142 18.4212 16.758 18.1158C16.6041 17.8104 16.526 17.4446 16.5236 17.0185V13.5455H18.0364V16.7486C18.0388 17.0705 18.1252 17.325 18.2956 17.5121C18.4661 17.6991 18.6945 17.7926 18.981 17.7926C19.1633 17.7926 19.3337 17.7512 19.4924 17.6683C19.651 17.5831 19.7788 17.4576 19.8759 17.2919C19.9753 17.1262 20.0239 16.9214 20.0215 16.6776ZM22.7443 19V13.5455H24.1861V14.5078H24.25C24.3636 14.1882 24.553 13.9361 24.8182 13.7514C25.0833 13.5668 25.4006 13.4744 25.7699 13.4744C26.1439 13.4744 26.4624 13.5679 26.7251 13.755C26.9879 13.9396 27.1631 14.1906 27.2507 14.5078H27.3075C27.4188 14.1953 27.62 13.9455 27.9112 13.7585C28.2048 13.5691 28.5516 13.4744 28.9517 13.4744C29.4607 13.4744 29.8738 13.6366 30.1911 13.9609C30.5107 14.2829 30.6705 14.7398 30.6705 15.3317V19H29.1612V15.63C29.1612 15.3269 29.0807 15.0997 28.9197 14.9482C28.7588 14.7966 28.5575 14.7209 28.3161 14.7209C28.0414 14.7209 27.8272 14.8085 27.6733 14.9837C27.5194 15.1565 27.4425 15.3849 27.4425 15.669V19H25.9759V15.598C25.9759 15.3305 25.8989 15.1174 25.745 14.9588C25.5935 14.8002 25.3935 14.7209 25.1449 14.7209C24.9768 14.7209 24.8253 14.7635 24.6903 14.8487C24.5578 14.9316 24.4524 15.0488 24.3743 15.2003C24.2962 15.3494 24.2571 15.5246 24.2571 15.7259V19H22.7443ZM31.8938 19V11.7273H33.4066V14.4616H33.4528C33.5191 14.3149 33.6149 14.1657 33.7404 14.0142C33.8683 13.8603 34.034 13.7325 34.2376 13.6307C34.4435 13.5265 34.6992 13.4744 35.0046 13.4744C35.4023 13.4744 35.7693 13.5786 36.1055 13.7869C36.4416 13.9929 36.7103 14.3042 36.9116 14.7209C37.1128 15.1352 37.2134 15.6548 37.2134 16.2798C37.2134 16.8883 37.1152 17.402 36.9187 17.821C36.7246 18.2377 36.4594 18.5537 36.1232 18.7692C35.7894 18.9822 35.4154 19.0888 35.0011 19.0888C34.7075 19.0888 34.4577 19.0402 34.2518 18.9432C34.0482 18.8461 33.8813 18.7242 33.7511 18.5774C33.6209 18.4283 33.5214 18.2779 33.4528 18.1264H33.3853V19H31.8938ZM33.3746 16.2727C33.3746 16.5971 33.4196 16.88 33.5096 17.1214C33.5996 17.3629 33.7298 17.5511 33.9002 17.6861C34.0707 17.8187 34.2778 17.8849 34.5217 17.8849C34.7679 17.8849 34.9762 17.8175 35.1467 17.6825C35.3171 17.5452 35.4461 17.3558 35.5337 17.1143C35.6237 16.8705 35.6687 16.59 35.6687 16.2727C35.6687 15.9579 35.6249 15.6809 35.5373 15.4418C35.4497 15.2027 35.3207 15.0156 35.1502 14.8807C34.9798 14.7457 34.7702 14.6783 34.5217 14.6783C34.2754 14.6783 34.0671 14.7434 33.8967 14.8736C33.7286 15.0038 33.5996 15.1884 33.5096 15.4276C33.4196 15.6667 33.3746 15.9484 33.3746 16.2727ZM39.7356 15.8466V19H38.2228V13.5455H39.6646V14.5078H39.7285C39.8493 14.1906 40.0517 13.9396 40.3358 13.755C40.6199 13.5679 40.9643 13.4744 41.3691 13.4744C41.7479 13.4744 42.0782 13.5573 42.3599 13.723C42.6416 13.8887 42.8606 14.1255 43.0169 14.4332C43.1731 14.7386 43.2512 15.1032 43.2512 15.527V19H41.7385V15.7969C41.7408 15.4631 41.6556 15.2027 41.4828 15.0156C41.31 14.8262 41.072 14.7315 40.769 14.7315C40.5654 14.7315 40.3855 14.7753 40.2292 14.8629C40.0753 14.9505 39.9546 15.0784 39.867 15.2464C39.7818 15.4122 39.738 15.6122 39.7356 15.8466ZM45.9989 19.103C45.6509 19.103 45.3408 19.0426 45.0685 18.9219C44.7963 18.7988 44.5808 18.6177 44.4222 18.3786C44.266 18.1371 44.1879 17.8364 44.1879 17.4766C44.1879 17.1735 44.2435 16.919 44.3548 16.7131C44.466 16.5071 44.6175 16.3414 44.8093 16.2159C45.0011 16.0904 45.2189 15.9957 45.4627 15.9318C45.7089 15.8679 45.967 15.8229 46.2369 15.7969C46.5541 15.7637 46.8098 15.733 47.0039 15.7045C47.198 15.6738 47.3389 15.6288 47.4265 15.5696C47.5141 15.5104 47.5579 15.4228 47.5579 15.3068V15.2855C47.5579 15.0606 47.4869 14.8866 47.3448 14.7635C47.2051 14.6404 47.0063 14.5788 46.7482 14.5788C46.476 14.5788 46.2594 14.6392 46.0984 14.7599C45.9374 14.8783 45.8308 15.0275 45.7788 15.2074L44.3796 15.0938C44.4506 14.7623 44.5903 14.4759 44.7987 14.2344C45.007 13.9905 45.2757 13.8035 45.6048 13.6733C45.9362 13.5407 46.3197 13.4744 46.7553 13.4744C47.0584 13.4744 47.3484 13.5099 47.6254 13.581C47.9047 13.652 48.1521 13.7621 48.3675 13.9112C48.5853 14.0604 48.757 14.2521 48.8825 14.4865C49.0079 14.7185 49.0707 14.9967 49.0707 15.321V19H47.636V18.2436H47.5934C47.5058 18.4141 47.3886 18.5644 47.2418 18.6946C47.0951 18.8224 46.9187 18.9231 46.7127 18.9964C46.5067 19.0675 46.2688 19.103 45.9989 19.103ZM46.4322 18.0589C46.6547 18.0589 46.8512 18.0152 47.0217 17.9276C47.1921 17.8376 47.3259 17.7169 47.4229 17.5653C47.52 17.4138 47.5685 17.2422 47.5685 17.0504V16.4716C47.5212 16.5024 47.4561 16.5308 47.3732 16.5568C47.2927 16.5805 47.2016 16.603 47.0998 16.6243C46.998 16.6432 46.8962 16.661 46.7944 16.6776C46.6926 16.6918 46.6003 16.7048 46.5174 16.7166C46.3398 16.7427 46.1848 16.7841 46.0522 16.8409C45.9196 16.8977 45.8166 16.9747 45.7433 17.0717C45.6699 17.1664 45.6332 17.2848 45.6332 17.4268C45.6332 17.6328 45.7077 17.7902 45.8569 17.8991C46.0084 18.0057 46.2002 18.0589 46.4322 18.0589ZM50.2443 19V13.5455H51.7571V19H50.2443ZM51.0043 12.8423C50.7794 12.8423 50.5864 12.7678 50.4254 12.6186C50.2668 12.4671 50.1875 12.286 50.1875 12.0753C50.1875 11.867 50.2668 11.6882 50.4254 11.5391C50.5864 11.3875 50.7794 11.3118 51.0043 11.3118C51.2292 11.3118 51.4209 11.3875 51.5795 11.5391C51.7405 11.6882 51.821 11.867 51.821 12.0753C51.821 12.286 51.7405 12.4671 51.5795 12.6186C51.4209 12.7678 51.2292 12.8423 51.0043 12.8423ZM54.4817 11.7273V19H52.9689V11.7273H54.4817Z"
        fill="white"
      />
      <path d="M29.5 34L26.4689 28.75L32.5311 28.75L29.5 34Z" fill="#ff3666" />
    </svg>
  );
};
export const PlusIconNew = () => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6912 4H33.3512C40.1512 4 44.0312 7.84 44.0312 14.66V33.34C44.0312 40.12 40.1712 44 33.3713 44H14.6912C7.87125 44 4.03125 40.12 4.03125 33.34V14.66C4.03125 7.84 7.87125 4 14.6912 4ZM25.6712 25.66H31.3512C32.2712 25.64 33.0112 24.9 33.0112 23.98C33.0112 23.06 32.2712 22.32 31.3512 22.32H25.6712V16.68C25.6712 15.76 24.9312 15.02 24.0112 15.02C23.0912 15.02 22.3512 15.76 22.3512 16.68V22.32H16.6912C16.2513 22.32 15.8313 22.5 15.5112 22.8C15.2113 23.12 15.0312 23.538 15.0312 23.98C15.0312 24.9 15.7712 25.64 16.6912 25.66H22.3512V31.32C22.3512 32.24 23.0912 32.98 24.0112 32.98C24.9312 32.98 25.6712 32.24 25.6712 31.32V25.66Z"
        fill="#FF0046"
      />
    </svg>
  );
};
export const CalendarIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z"
        stroke="#7f8899"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 10H21"
        stroke="#7f8899"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 2V6"
        stroke="#7f8899"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 2V6"
        stroke="#7f8899"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StarsIcon = (props: { width?: number; height?: number }) => {
  const { width = 56, height = 57 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 56 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.8897 51.9265C39.4063 51.9341 39.745 51.5268 39.7943 50.8886C39.9 49.5005 39.9492 48.101 40.1462 46.7269C41.0567 40.3827 45.1421 35.6525 51.0256 34.1591C52.3193 33.8305 53.6623 33.7125 54.986 33.5272C55.5578 33.4473 55.9782 33.1339 55.9986 32.6479C56.0239 32.0414 55.6935 31.7166 55.1758 31.5669C55.0425 31.5288 54.8995 31.5326 54.7614 31.5085C53.2875 31.2497 51.7728 31.1368 50.3469 30.7003C45.9445 29.3553 42.7456 26.4903 41.0171 21.939C40.1054 19.5371 39.763 17.0172 39.7462 14.439C39.7414 13.5914 39.4123 13.1168 38.8549 13.1042C38.2843 13.0902 37.9924 13.5444 37.924 14.3907C37.8014 15.9032 37.745 17.4359 37.4675 18.9192C36.5918 23.6113 34.2699 27.2503 30.1954 29.505C27.8938 30.7777 25.4277 31.426 22.8307 31.5187C22.0944 31.544 21.7088 31.9196 21.7244 32.5528C21.74 33.172 22.1052 33.4613 22.8211 33.5298C23.8541 33.6287 24.8932 33.7188 25.913 33.9142C31.9059 35.0638 36.2843 39.5491 37.4783 45.8463C37.7822 47.4514 37.8375 49.111 37.978 50.749C38.0417 51.4977 38.3324 51.9189 38.8909 51.9278L38.8897 51.9265ZM20.2757 45.0304C20.2625 44.4341 19.8253 44.0953 19.0229 44.0623C15.0288 43.8974 12.081 41.2912 11.287 37.1726C11.1321 36.3719 11.1141 35.5396 11.0492 34.7212C10.9939 34.0348 10.6528 33.597 10.1399 33.5945C9.60894 33.5919 9.2702 34.0068 9.23056 34.6996C9.20413 35.164 9.1753 35.6271 9.14287 36.0915C8.8726 40.0287 6.4966 42.9572 2.85331 43.8047C2.23228 43.9494 1.59084 43.9938 0.956594 44.0712C0.336768 44.1473 -0.0139871 44.5026 0.000427489 45.0621C0.0148421 45.6052 0.341572 45.9237 0.945783 45.9833C1.28453 46.0163 1.62327 46.0468 1.96201 46.0836C5.33022 46.4528 7.92124 48.7164 8.79572 52.1701C9.05638 53.2004 9.11284 54.2916 9.22335 55.3587C9.30023 56.101 9.63417 56.5184 10.2372 56.4994C10.7165 56.4854 10.9255 56.1517 10.9579 55.398C10.9807 54.8702 11.0048 54.3411 11.0696 53.8183C11.4444 50.7998 12.7333 48.4233 15.4036 47.0466C16.5868 46.4363 17.8445 46.1267 19.161 46.0772C19.8613 46.0506 20.2877 45.6407 20.2733 45.0304H20.2757ZM28.2506 11.9584C28.259 11.4192 27.9299 11.0537 27.3485 10.9763C26.8524 10.9104 26.3479 10.9027 25.859 10.8038C22.749 10.1681 20.4871 8.41457 19.5442 5.13337C19.2115 3.97747 19.1658 2.72767 19.0181 1.51594C18.9424 0.887871 18.6649 0.52118 18.1556 0.500878C17.6246 0.479308 17.2607 0.856151 17.2102 1.49945C17.1862 1.81539 17.197 2.13386 17.1838 2.45107C16.988 6.82345 14.6264 9.83312 10.636 10.7556C10.015 10.8989 9.3663 10.9078 8.73566 11.0131C8.26238 11.0918 7.97049 11.4153 7.9885 11.928C8.00652 12.4507 8.278 12.7984 8.79932 12.8605C9.15729 12.9037 9.51885 12.9113 9.87561 12.9659C13.1177 13.4594 15.5682 15.1 16.624 18.5018C16.9976 19.7046 17.0409 21.0255 17.2006 22.2968C17.2835 22.963 17.603 23.3728 18.1532 23.3779C18.6445 23.3817 18.922 23.0251 18.9688 22.3374C19.0157 21.6637 19.0229 20.9823 19.1226 20.3174C19.597 17.153 21.1394 14.8107 24.0271 13.6701C25.0385 13.2704 26.1593 13.16 27.2392 12.976C27.8662 12.8694 28.2434 12.5586 28.2518 11.9597L28.2506 11.9584Z"
        fill="#BA2AE1"
      />
    </svg>
  );
};
<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M16.2976 15.5383C16.3785 17.3704 14.8999 18.9196 12.9953 18.9975C12.8551 19.0034 6.01604 18.9896 6.01604 18.9896C4.12069 19.1335 2.46188 17.7715 2.31238 15.9463C2.30112 15.8103 2.30419 8.47219 2.30419 8.47219C2.22023 6.63815 3.69678 5.08499 5.60236 5.00418C5.74469 4.99728 12.5745 5.01009 12.5745 5.01009C14.4791 4.86818 16.143 6.24001 16.2904 8.07405C16.3007 8.2061 16.2976 15.5383 16.2976 15.5383Z"
    stroke="#130F26"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M16.3008 9.97984L19.5938 7.28484C20.4098 6.61684 21.6338 7.19884 21.6328 8.25184L21.6208 15.6008C21.6198 16.6538 20.3948 17.2308 19.5808 16.5628L16.3008 13.8678"
    stroke="#130F26"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>;

export const VideoIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2976 15.5383C16.3785 17.3704 14.8999 18.9196 12.9953 18.9975C12.8551 19.0034 6.01604 18.9896 6.01604 18.9896C4.12069 19.1335 2.46188 17.7715 2.31238 15.9463C2.30112 15.8103 2.30419 8.47219 2.30419 8.47219C2.22023 6.63815 3.69678 5.08499 5.60236 5.00418C5.74469 4.99728 12.5745 5.01009 12.5745 5.01009C14.4791 4.86818 16.143 6.24001 16.2904 8.07405C16.3007 8.2061 16.2976 15.5383 16.2976 15.5383Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3008 9.97984L19.5938 7.28484C20.4098 6.61684 21.6338 7.19884 21.6328 8.25184L21.6208 15.6008C21.6198 16.6538 20.3948 17.2308 19.5808 16.5628L16.3008 13.8678"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Iconly/Light/Show">
        <g id="Show">
          <path
            id="Stroke 1"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.1615 12.0531C15.1615 13.7991 13.7455 15.2141 11.9995 15.2141C10.2535 15.2141 8.8385 13.7991 8.8385 12.0531C8.8385 10.3061 10.2535 8.89108 11.9995 8.89108C13.7455 8.89108 15.1615 10.3061 15.1615 12.0531Z"
            stroke="#130F26"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.998 19.3549C15.806 19.3549 19.289 16.6169 21.25 12.0529C19.289 7.48888 15.806 4.75089 11.998 4.75089H12.002C8.194 4.75089 4.711 7.48888 2.75 12.0529C4.711 16.6169 8.194 19.3549 12.002 19.3549H11.998Z"
            stroke="#130F26"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export const KebabMenu = () => {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Kebab-Menu"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect id="Container" x="0" y="0" width="24" height="24"></rect>
        <path
          d="M12,6 C12.5522847,6 13,5.55228475 13,5 C13,4.44771525 12.5522847,4 12,4 C11.4477153,4 11,4.44771525 11,5 C11,5.55228475 11.4477153,6 12,6 Z"
          id="shape-03"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeDasharray="0,0"
        ></path>
        <path
          d="M12,13 C12.5522847,13 13,12.5522847 13,12 C13,11.4477153 12.5522847,11 12,11 C11.4477153,11 11,11.4477153 11,12 C11,12.5522847 11.4477153,13 12,13 Z"
          id="shape-03"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeDasharray="0,0"
        ></path>
        <path
          d="M12,20 C12.5522847,20 13,19.5522847 13,19 C13,18.4477153 12.5522847,18 12,18 C11.4477153,18 11,18.4477153 11,19 C11,19.5522847 11.4477153,20 12,20 Z"
          id="shape-03"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeDasharray="0,0"
        ></path>
      </g>
    </svg>
  );
};

export const EditIconDynamicData = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Iconly/Light/Edit Square">
        <g id="Edit Square">
          <path
            id="Stroke 1"
            d="M11.4923 2.789H7.7533C4.6783 2.789 2.75031 4.966 2.75031 8.048V16.362C2.75031 19.444 4.6693 21.621 7.7533 21.621H16.5773C19.6623 21.621 21.5813 19.444 21.5813 16.362V12.334"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.82782 10.9209L16.3008 3.4479C17.2318 2.5179 18.7408 2.5179 19.6718 3.4479L20.8888 4.6649C21.8198 5.5959 21.8198 7.1059 20.8888 8.0359L13.3798 15.5449C12.9728 15.9519 12.4208 16.1809 11.8448 16.1809H8.09882L8.19282 12.4009C8.20682 11.8449 8.43382 11.3149 8.82782 10.9209Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 5"
            d="M15.1652 4.60251L19.7312 9.16851"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export const DuplicateIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 9H11C9.89543 9 9 9.89543 9 11V20C9 21.1046 9.89543 22 11 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 15H4C3.46957 15 2.96086 14.7893 2.58579 14.4142C2.21071 14.0391 2 13.5304 2 13V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H13C13.5304 2 14.0391 2.21071 14.4142 2.58579C14.7893 2.96086 15 3.46957 15 4V5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RenameIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Iconly/Light/Edit">
        <g id="Edit">
          <path
            id="Stroke 1"
            d="M13.7474 20.4429H21"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.78 3.79479C13.5557 2.86779 14.95 2.73186 15.8962 3.49173C15.9485 3.53296 17.6295 4.83879 17.6295 4.83879C18.669 5.46719 18.992 6.80311 18.3494 7.82259C18.3153 7.87718 8.81195 19.7645 8.81195 19.7645C8.49578 20.1589 8.01583 20.3918 7.50291 20.3973L3.86353 20.443L3.04353 16.9723C2.92866 16.4843 3.04353 15.9718 3.3597 15.5773L12.78 3.79479Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 5"
            d="M11.0208 6.00089L16.4731 10.188"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export const DeleteIconDynamicData = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.883 6.55078C12.883 6.55078 12.521 11.0408 12.311 12.9321C12.211 13.8354 11.653 14.3648 10.739 14.3814C8.9997 14.4128 7.25836 14.4148 5.5197 14.3781C4.64036 14.3601 4.0917 13.8241 3.9937 12.9368C3.78236 11.0288 3.42236 6.55078 3.42236 6.55078"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8053 4.39779H2.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6269 4.39827C11.1036 4.39827 10.6529 4.02827 10.5502 3.5156L10.3882 2.70493C10.2882 2.33093 9.94956 2.07227 9.56356 2.07227H6.74156C6.35556 2.07227 6.01689 2.33093 5.91689 2.70493L5.75489 3.5156C5.65222 4.02827 5.20156 4.39827 4.67822 4.39827"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PlusIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Iconly/Light/Plus">
        <g id="Plus">
          <path
            id="Line_185"
            d="M12 8.3273V15.6537"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Line_186"
            d="M15.6667 11.9905H8.33334"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Path"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export const RotateIcon = () => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4V10H7"
        stroke="#8C8C8C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.51 15C4.15839 16.8404 5.38734 18.4202 7.01166 19.5014C8.63598 20.5826 10.5677 21.1066 12.5157 20.9945C14.4637 20.8824 16.3226 20.1402 17.8121 18.8798C19.3017 17.6193 20.3413 15.909 20.7742 14.0064C21.2072 12.1037 21.0101 10.112 20.2126 8.3311C19.4152 6.55025 18.0605 5.0768 16.3528 4.13277C14.6451 3.18874 12.6769 2.82527 10.7447 3.09712C8.81245 3.36897 7.02091 4.26142 5.64 5.64L1 10"
        stroke="#8C8C8C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HelpCircleIcon = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6684_3448)">
        <path
          d="M6.99984 12.9215C10.2215 12.9215 12.8332 10.3099 12.8332 7.08822C12.8332 3.86655 10.2215 1.25488 6.99984 1.25488C3.77818 1.25488 1.1665 3.86655 1.1665 7.08822C1.1665 10.3099 3.77818 12.9215 6.99984 12.9215Z"
          stroke="#7F8899"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 10.0049H7.00583"
          stroke="#7F8899"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.30273 5.33822C5.43988 4.94836 5.71057 4.61962 6.06687 4.41022C6.42318 4.20082 6.84209 4.12427 7.24942 4.19414C7.65675 4.26401 8.02621 4.47578 8.29236 4.79195C8.55852 5.10812 8.70418 5.50828 8.70357 5.92156C8.70357 7.08822 6.95357 7.67156 6.95357 7.67156"
          stroke="#7F8899"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6684_3448">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0 0.0878906)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
